import FormInput from '../components/FormInput';
import AudioPreview from './AudioPreview';
import PropTypes from 'prop-types'
import { getData } from '../global/func';
import { useState, useEffect, useCallback } from 'react';

const SettingAzan = ( { DeviceKey, DeviceSetting, onSettingChange } ) => {
    
    // Enabled Components State
    // Same as Recitation: these are seeded at mount, before the settings arrive,
    // and are re-synced below so the panels match the switches above them.
    const [azanEnabled, setAzanEnabled] = useState(DeviceSetting['azan'] === 'true');
    const [azanSound, setAzanSound] = useState(`${import.meta.env.REACT_APP_AUDIO_URL}/azan/${DeviceSetting['azan-sound']}.mp3`);
    const [azanDuaaState, setAzanDuaaState] = useState(DeviceSetting['azan-duaa'] === 'true');

    useEffect(() => {
        setAzanEnabled(DeviceSetting['azan'] === 'true');
        setAzanDuaaState(DeviceSetting['azan-duaa'] === 'true');
    }, [DeviceSetting]);
    
    const [azanList, setAzanList] = useState([]);

    // Get the Azan List
    const getAzanList = useCallback(async () => {
        const sAuthData = {
            DEVICE_KEY: DeviceKey,
            SESSION_ID: import.meta.env.REACT_APP_SESSION_ID,
        };

        // Get Countries from API
        const url = encodeURI(import.meta.env.REACT_APP_API_SERVER_URL + '/options/?option=azan_list');
        const cList = await getData(url, sAuthData, sAuthData);

        const newList = JSON.parse(cList[0].data).map((e) => {
            return {id: e.id, description: e.description} 
        });
        
        // Update County/City List State
        setAzanList( newList );
    }, [DeviceKey])

    useEffect(() => {
        // Get Azan List
        getAzanList();
    }, [DeviceKey, getAzanList])

    const setSetting = (changedSettings) => {
        var tempSettings = [{...DeviceSetting}];
            
        changedSettings.forEach(({setting, value}) => {
            try {
                // change the setting
                tempSettings[0][setting] = value;
            } catch (error) {
                console.log('ERROR: getSetting', setting, DeviceSetting, value, error);
            }
        });
        // call the Change State
        onSettingChange( tempSettings );
    }
    
    const onAzanChange = (e) => {

        // Update the Setting Change
        let settingArr = [{setting: 'azan', value: `${e}`}];
        if (!e) {
            // Change the Azan Duaa State
            setAzanDuaaState ( false );

            // Add it to the Setting array
            settingArr.push({setting: 'azan-duaa', value: 'false'});
        }
        setSetting(settingArr);
        setAzanEnabled( e );
    }

    const onAzanSoundChange = (e) => {
    const azanFile = `${import.meta.env.REACT_APP_AUDIO_URL}/azan/${e}.mp3`;
        setSetting( [{setting: 'azan-sound', value: `${e}`}] );
        setAzanSound( azanFile );
    }

    const onAzanDuaaChange = (e) => {

        setAzanDuaaState ( e );
        setSetting([{setting: 'azan-duaa', value: `${e}`}]);
    }

    return (
        <>
            <FormInput name="azan"
                labelText="Call to prayer"
                hint="Plays the azan through the television"
                inputType="checkbox"
                value={DeviceSetting['azan'] === 'true'}
                onValueChange={onAzanChange} />

            {azanEnabled && (
                <>
                    <FormInput name="azan-sound"
                            labelText="Muezzin"
                            inputType="select"
                            value={DeviceSetting['azan-sound']}
                            options={azanList}
                            maxLen={40}
                            onValueChange={onAzanSoundChange} />

                    <AudioPreview src={azanSound} />

                    <FormInput name="azan-duaa"
                        labelText="Duaa after the azan"
                        hint="Plays once the call has finished"
                        inputType="checkbox"
                        value={azanDuaaState}
                        onValueChange={onAzanDuaaChange} />
                </>
            )}
        </>
    );
}

SettingAzan.propTypes = {
    DeviceSetting: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
}

export default SettingAzan

